import { AloAccompagnement } from '@/models/alo/AloAccompagnement';
import { AloAllergene } from '@/models/alo/AloAllergene';
import { AloBio } from '@/models/alo/AloBio';
import { AloArbo } from '@/models/alo/AloArbo';
import { AloIcon } from '@/models/alo/AloIcon';
import { AloPanier} from '@/models/alo/AloPanier';
import { AloPlat } from '@/models/alo/AloPlat';
import { AloSection } from '@/models/alo/AloSection';
import { Configuration, getDefaultConfiguration } from '@/models/alo/Configuration';
import { Crenau } from '@/models/alo/Crenau';
import { StateItem, buildStateItem } from '@/models/alo/StateItem';

export interface IRoomserviceState {     
    datasStatus:string
    sectionsDic: {[id:number]:AloSection}
    sectionsList : Array<number>
    arbosDic:  {[id:number]:AloArbo}
    arbosList: Array<number>    
    allergenesDic: {[id:number]:AloAllergene}
    biosDic: {[id:number]:AloBio}
    accompagnementsDic: {[id:number]:AloAccompagnement}
    platsDic: {[id:number]:AloPlat}
    iconsDic:  {[id:number]:AloIcon}
    configuration:Configuration
    panier:AloPanier    
    crenaux:Array<Crenau>
    lastSectionId:number
}

var pan = localStorage.getItem('tbrs_panier') 

//Initial State
const state: IRoomserviceState = {  
    
    datasStatus:'',
    sectionsDic: {} as {[id:number]:AloSection},
    sectionsList:[],
    arbosDic: {} as {[id:number]:AloArbo},
    arbosList:[],
    allergenesDic: {} as {[id:number]:AloAllergene},
    biosDic: {} as {[id:number]:AloBio},
    accompagnementsDic: {} as {[id:number]:AloAccompagnement},
    platsDic: {} as {[id:number]:AloPlat},
    iconsDic: {} as {[id:number]:AloIcon},
    configuration: getDefaultConfiguration(),
    panier: pan?new AloPanier(JSON.parse(pan)):new AloPanier(),
    crenaux:[],    
    lastSectionId:-1
  
}
export default state